<template>
  <div
    class="login_background flex justify-center align-center flex-col items-center h-screen w-full bg-no-repeat bg-right"
    :style="{ backgroundImage: `url(${require('images/login_background.png')})` }"
  >
    <div class="flex justify-start flex-col" style="width: 450px">
      <div class="self-center mb-10">
        <logoSvg />
      </div>
      <ProgressBar></ProgressBar>
      <div
        class="w-4 h-0.5 flex-shrink-0 bg-coach-green-500 my-4 self-center"
      ></div>
      <div class="info-form-div">
        <div class="main-body">
          <form
            novalidate="novalidate"
            class="simple_form new_user"
            accept-charset="UTF-8"
            method="post"
          >
            <fieldset>
              <div class="b-5 input-theme">
                <span class="text-2xl font-medium text-black">My business is called</span>
                <input
                  tabindex="1"
                  class="string optional organization-name w-full rounded-lg mt-4"
                  type="text"
                  v-model="form.name"
                  placeholder="Business Name*"
                />
              </div>

              <div class="mt-6">
                <label class="font-medium text-2xl text-primary">I am a</label>
                <select
                  v-model="form.signup_coach_type"
                  tabindex="2"
                  class="personal-info-select mx-0 w-full mt-2"
                >
                  <option value="">Coach Type</option>
                  <option
                    v-for="obj in coachTypes"
                    class="cursor-pointer"
                    v-bind:value="obj"
                    :key="obj"
                  >
                    {{ obj }}
                  </option>
                </select>
              </div>

              <div class="mt-6">
                <label class="font-medium text-2xl text-primary">I have</label>
                <select
                  v-model="form.signup_clients"
                  tabindex="3"
                  class="personal-info-select mx-0 w-full mt-2"
                >
                  <option value=""># of clients</option>
                  <option
                    v-for="obj in numberOfClients"
                    class="cursor-pointer"
                    v-bind:value="obj"
                    :key="obj"
                  >
                    {{ obj }}
                  </option>
                </select>
              </div>

              <div class="mt-6">
                <label class="font-medium text-2xl text-primary">My coaching is</label>
                <select
                  v-model="form.signup_coaching_style"
                  tabindex="4"
                  class="personal-info-select mx-0 w-full mt-2"
                >
                  <option value="">Location style</option>
                  <option
                    v-for="obj in coachingStyles"
                    class="cursor-pointer"
                    v-bind:value="obj"
                    :key="obj"
                  >
                    {{ obj }}
                  </option>
                </select>
              </div>

              <div class="mt-6">
                <label class="font-medium text-2xl text-primary">My team size is</label>
                <select
                  v-model="form.signup_teammates"
                  tabindex="5"
                  class="personal-info-select mx-0 w-full mt-2"
                >
                  <option value="">Team size</option>
                  <option
                    v-for="obj in teamSizes"
                    class="cursor-pointer"
                    v-bind:value="obj"
                    :key="obj"
                  >
                    {{ obj }}
                  </option>
                </select>
              </div>

              <input
                type="button"
                @click="submit"
                value="Next"
                tabindex="6"
                class="btn button w-full rounded-lg mt-8"
              />
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiUrls from '../../api-url';
import { mapGetters, mapState } from 'vuex';
import getters from '../../stores/login-store/getters/login-getters';
import AuthenticationMixin from '../../authentication-mixin';
import ProgressBar from '../shared/progress-bar';
import logoSvg from '../../svgs/logoSvg.vue';

export default {
  components: { ProgressBar, logoSvg },
  mixins: [ApiUrls, AuthenticationMixin],
  data() {
    return {
      form: {
        name: '',
        signup_coach_type: '',
        signup_clients: '',
        signup_coaching_style: '',
        signup_teammates: '',
      },
      coachTypes: [
        'Fitness Coach',
        'Nutrition Coach',
        'Personal Trainer',
        'Gym Owner',
        'Health Coach',
        'Other',
      ],
      numberOfClients: [
        'No clients yet',
        '1-10 clients',
        '10-50 clients',
        '50+ clients',
      ],
      coachingStyles: [
        'Mostly online',
        'Mostly in-person',
        'Combo of both',
      ],
      teamSizes: [
        "No teammates - it's just me",
        '1',
        '2',
        '3+ on my team',
      ],
    };
  },
  beforeCreate: function() {
    document.body.style.backgroundColor = '#FFFFFF';
  },
  async created() {
    await this.get_info();
  },
  computed: {
    ...mapState(['userForm']),
    ...mapGetters(['SIGN_UP_BUILD_SELECTION']),
  },
  methods: {
    async get_info() {
      const { data } = await this.axiosInstance.get(
        this.organizationUrl + 'get_signup_info',
      );
      if (data.success) {
        this.form.name = data.result.name || '';
        this.form.signup_coach_type = data.result.signup_coach_type || '';
        this.form.signup_clients = data.result.signup_clients || '';
        this.form.signup_coaching_style = data.result.signup_coaching_style || '';
        this.form.signup_teammates = data.result.signup_teammates || '';
      }
    },
    isValid() {
      if (!this.form.name) {
        this.$toast.show('Business name is required.', this.toasted_options.error);
        return false;
      }
      return true;
    },
    async submit() {
      if (!this.isValid()) return;

      try {
        const { data } = await this.axiosInstance.post(
          this.organizationUrl + 'save_signup_coach_info',
          this.form,
        );
        if (data.success) {
          this.$store.commit('setUserForm', this.form);
          this.$store.commit('setSelectedStep', getters.SIGN_UP_BUILD_SELECTION());
        } else {
          this.$toast.show('Failed to save. Please try again.', this.toasted_options.error);
        }
      } catch (error) {
        this.$toast.show('Failed to save. Please try again.', this.toasted_options.error);
      }
    },
  },
};
</script>
